import { client, getUrl } from "../../../utils";

export const editConfigRequest = ({ id, initialConfig }) => client.put(`config/${id}`, initialConfig);

export const getHttpResponseRequest = ({ id, ...searchParams }) => client.get(getUrl(`scrape-task/${id}/http-response`, searchParams));

export const getConfigRequest = (searchParams) => client.get(getUrl("configs", searchParams));

export const getNormalizerUrlsByCode = (code, body, params) => client.post(getUrl(`normalizer/${code}/apply`, params), body);

export const getTracksRequest = (filterParams) => client.get(getUrl("scrape-tasks", filterParams));
